const styles = {
  container: {
    position: "relative",
    display: "flex",
    alignItems: "flex-start",
    padding: [[16, 0]],
    borderBottom: "1px solid #000",
    "&:last-child": {
      borderBottom: "none",
      marginBottom: 64
    },
    "& p, small, button": {
      lineHeight: "1.4em",
      fontSize: "inherit"
    }
  },
  preview: {
    width: 80,
    height: 80,
    borderRadius: 2,
    objectFit: "cover"
  },
  details: {
    flex: 1,
    paddingRight: "2.2em",
    marginLeft: "1em",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    "&>*": {
      marginBottom: "0.5em"
    },
    "&>small": {
      color: "rgba(0,0,0,0.54)"
    }
  },
  title: {
    textTransform: "uppercase",
    fontWeight: 500
  },
  counter: {
    height: "0.6em"
  },
  removeButton: {
    position: "absolute",
    fontSize: "0.5em",
    top: 16,
    right: 16,
    cursor: "pointer"
  },
  price: {
    position: "absolute",
    bottom: 24,
    right: 16,
    fontWeight: 500,
    marginBottom: 0
  }
};

export default styles;



// WEBPACK FOOTER //
// ./src/components/OrderItem/styles.js